
import moment from "moment";
import GiftCardUsageArea from "./enums/GiftCardUsageAreaEnum.js";
import GiftCardStatus from "./enums/GiftCardStatusEnum.js";
export default {
  name: "MyGiftCard",
  data() {
    return {
      flipped: false,
    };
  },
  props: {
    /**
     * MyGiftCard item object
     * Properties
     *  barcode - required
     *  name - required
     *  originalAmount - required
     *  restAmount - required
     *  giftCardFrom - required
     *  message - required
     *  messageUrl
     *  image - required
     *  status - FULL_CREDIT, USED, EMPTY, EXPIRED - required
     *  usageArea - ALL_CHAINS, SITE_WISE, CHAIN_WISE - required
     *  usageDescription - required
     *  expirationDate - required
     */
    item: {
      type: Object,
      default: false,
    },
  },
  computed: {
    giftCardValue() {
      switch (this.item.status) {
        case GiftCardStatus.FULL_CREDIT:
          return "Kr " + this.formatExample(this.item.originalAmount, 2);
        case GiftCardStatus.USED:
        case GiftCardStatus.SITE_UNACTIVE:
          return (
            "Kr " +
            this.formatExample(this.item.restAmount, 1) +
            " (av " +
            this.formatExample(this.item.originalAmount, 2) +
            ")"
          );
        case GiftCardStatus.EMPTY:
        case GiftCardStatus.EXPIRED:
          return (
            "Kr " +
            0 +
            " (av " +
            this.formatExample(this.item.originalAmount, 2) +
            ")"
          );
      }
    },
    giftCardButtonText() {
      switch (this.item.status) {
        case GiftCardStatus.FULL_CREDIT:
        case GiftCardStatus.USED:
          return "Bruk gavekort";
        case GiftCardStatus.EMPTY:
          return "Gavekort oppbrukt";
        case GiftCardStatus.EXPIRED:
        case GiftCardStatus.SITE_UNACTIVE:
          return "Gavekort utløpt";
      }
    },
    flipButtonAvailable() {
      return (
        (this.item.usageArea == GiftCardUsageArea.CHAIN_WISE ||
          this.item.usageArea == GiftCardUsageArea.SITE_WISE) &&
        this.item.messageUrl
      );
    },

    buttonDisabled() {
      return (
        this.item.status == GiftCardStatus.EMPTY ||
        this.item.status == GiftCardStatus.EXPIRED ||
        this.item.status == GiftCardStatus.SITE_UNACTIVE
      );
    },
    shouldDisplayUsageDescription() {
      return this.item.status !== GiftCardStatus.EXPIRED;
    },
    shouldDisplayExpirationDate() {
      return this.item.status !== GiftCardStatus.SITE_UNACTIVE;
    },
  },
  methods: {
    rotateImage() {
      this.flipped = !this.flipped;
    },
    formatText(text) {
      return text.replace(/\r?\n/g, "</br>");
    },
    formatDate(date) {
      return moment(date).format("DD.MM.YYYY.");
    },
    formatExample(value, format) {
      if (value % 1 == 0 && format == 1) {
        return value + ", –";
      } else if (value % 1 == 0 && format == 2) {
        return value;
      } else {
        return value.toFixed(2).replace(".", ",");
      }
    },
    showBarcode() {
      this.$emit("show-barcode", this.item);
    },
  },
};
